import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { AppSettingService } from '../services/app-setting.service';
import { EMPTY, Observable, mergeMap, of, take } from 'rxjs';
import { AppSettingModel } from '../models/app-setting-model';

@Injectable({
  providedIn: 'root'
})
export class LastIndexDateResolverService implements Resolve<AppSettingModel> {

  constructor(private svc: AppSettingService) { }

  resolve(route: ActivatedRouteSnapshot, state:RouterStateSnapshot): Observable<any> {
    return this.svc.getLastAdamsUpdate().pipe(take(1), mergeMap(e => {
      if(e) {
        this.svc.setLastIndex(e);
        return of(e);
      } else {
        return EMPTY;
      }
    }));
  }
}